import { ApiGetRequest } from 'src/app/model/api/api-request/api-get-request';
import { ApiParameters } from 'src/app/model/api/api-request/api-parameters';
import { AppConfigService } from 'src/app/services/app-config.service';

export class CompetitionPrizesRequest extends ApiGetRequest
{
    public constructor(competitionId: number, webapiBasepath: string)
    {
        super(  'competitionprizes', 
                new ApiParameters().addQueryParameter("competitionId", competitionId),
                null,
                webapiBasepath
            );
    }
}
